import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Chip,
} from '@mui/material'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'
import React from 'react'
import { Send, ThumbUp, ThumbDown, Receipt, Circle } from '@mui/icons-material'

interface QuotationStatusHistoryEntry {
  id: number
  document_id: number
  user_id: number
  user_name: string
  from_status: string | null
  from_status_label: string | null
  to_status: string
  to_status_label: string
  comment: string | null
  created_at: string
  updated_at: string
}

interface QuotationStatusHistoryProps {
  history: QuotationStatusHistoryEntry[]
}

const getStatusIcon = (status: string) => {
  switch (status) {
    case 'not_sent':
      return <Circle />
    case 'sent':
      return <Send />
    case 'accepted':
      return <ThumbUp />
    case 'rejected':
      return <ThumbDown />
    case 'invoiced':
      return <Receipt />
    default:
      return <Circle />
  }
}

const getStatusColor = (status: string): 'default' | 'primary' | 'success' | 'error' | 'info' => {
  switch (status) {
    case 'not_sent':
      return 'default'
    case 'sent':
      return 'primary'
    case 'accepted':
      return 'success'
    case 'rejected':
      return 'error'
    case 'invoiced':
      return 'info'
    default:
      return 'default'
  }
}

export const QuotationStatusHistory: React.FC<QuotationStatusHistoryProps> = ({ history }) => {
  if (!history || history.length === 0) {
    return null
  }

  return (
    <Card
      sx={{ mb: 2 }}
      elevation={1}>
      <Box sx={{ p: 1.5, pb: 0 }}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600 }}>
          Status geschiedenis
        </Typography>
      </Box>
      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 1 }}>Datum</TableCell>
              <TableCell sx={{ py: 1 }}>Status</TableCell>
              <TableCell sx={{ py: 1 }}>Door</TableCell>
              <TableCell sx={{ py: 1 }}>Opmerking</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map(entry => (
              <TableRow
                key={entry.id}
                sx={{ '&:last-child td': { border: 0 } }}>
                <TableCell sx={{ py: 1, fontSize: '0.8rem' }}>
                  {dayjs(entry.created_at).locale('nl').format('DD MMM YYYY HH:mm')}
                </TableCell>
                <TableCell sx={{ py: 1 }}>
                  <Chip
                    label={entry.to_status_label}
                    color={getStatusColor(entry.to_status)}
                    size="small"
                    sx={{ height: 24, fontSize: '0.75rem' }}
                  />
                </TableCell>
                <TableCell sx={{ py: 1, fontSize: '0.8rem' }}>{entry.user_name}</TableCell>
                <TableCell sx={{ py: 1, fontSize: '0.8rem', fontStyle: entry.comment ? 'italic' : 'normal' }}>
                  {entry.comment || '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  )
}
